import { useContext, useEffect } from 'react';
import withFilteredQueryRequest from '../../shared/components/table/withFilteredRequest';
import { AppContext } from '../../../main/context/Provider';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { AddButton } from '../../shared/components/AddButton';
import { Private_Routes } from '../../../main/constants';
import CustomerTable from '../components/CustomerTable';

export const CustomerPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const CustomerList = withFilteredQueryRequest(
        'customers/customers-list',
        CustomerTable
    );

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Clientes');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Clientes',
                route: Private_Routes.CUSTOMER_PAGE,
            },
        ]);
    }, [lang]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-body'>
                        <div className='mb-3'>
                            <AddButton href={Private_Routes.CREATE_CUSTOMER} />
                        </div>
                        <CustomerList />
                    </div>
                </div>
            </div>
        </div>
    );
};
